// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5c60a3f7","703":"9635e9f2"}[chunkId] + ".chunk.js";
};